import { capitalize, truncate } from 'lodash';

const MAX_LENGTH = 11;

const jackpotMessage = (winners, username) => {
  if (!winners || !winners.length > 0) {
    return '';
  }
  let result = '';
  const _winners = winners.slice();
  const userIndex = _winners.indexOf(username);
  if (userIndex >= 0) {
    return 'You won';
  } else {
    _winners.forEach((username) => {
      if (username.length > MAX_LENGTH) {
        // eslint-disable-next-line no-param-reassign
        username = truncate(username, { length: 8 });
      }
    });
    result += capitalize(_winners[0]);
    _winners.splice(0, 1);
  }
  const length = _winners.length;
  if (length === 0) {
    result += ' won';
  } else if (length === 1) {
    result += ` and ${_winners[0]} won`;
  } else if (length === 2) {
    result += `, ${_winners[0]} and ${_winners[1]} won`;
  } else if (length >= 3) {
    result += `, ${_winners[0]}, ${_winners[1]} and ${length - 2} more won`;
  }
  return result;
};

export default jackpotMessage;
